import { createContext } from 'react';

export interface AccountApprovalActionsType {
    setApproverParentEmail: (email: string | null) => void;
    setApproverParentHasGivenConsent: (consent: boolean) => void;
}

const initialAccountApprovalActions = {
    setApproverParentEmail: () => {},
    setApproverParentHasGivenConsent: () => {},
};

export const AccountApprovalActions = createContext<AccountApprovalActionsType>(initialAccountApprovalActions);
